function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

// 쿠키에서 값을 읽어오는 함수
function getCookie(name, value) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return typeof value !== "undefine" ? value : null;
}

// 쿠키에서 값을 삭제하는 함수
function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

// Global
window.cssRound = (strategy, value, interval) => {
    if (interval === 0) return NaN;
    const divided = value / interval;
    switch (strategy) {
        case "up":
            return Math.ceil(divided) * interval;
        case "down":
            return Math.floor(divided) * interval;
        case "to-zero":
            return (value >= 0 ? Math.floor(divided) : Math.ceil(divided)) * interval;
        case "nearest":
        default:
            return Math.round(divided) * interval;
    }
};

window.adjustPatternWidth = function (element, initialWidth = false) {
    if (initialWidth) {
        element.style.width = "100%";
    }

    const currentWidth = element.offsetWidth;
    const adjustedWidth = cssRound("nearest", currentWidth, 5.36);
    element.style.width = `${adjustedWidth}px`;
};

window.adjustPatternWidthAuto = function (elements, initialWidth = false) {
    elements.forEach((element) => {
        adjustPatternWidth(element, true);
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                adjustPatternWidth(entry.target, true);
            }
        });
        observer.observe(element);
    });

    window.addEventListener("resize", function () {
        elements.forEach((element) => {
            if (window.adjustPatternWidth) {
                window.adjustPatternWidth(element, true);
            }
        });
    });
};

// 가격 포맷
window.formatMoney = function (money, currency = "KRW") {
    const amount = Math.floor(money / 100);
    return `${currency} ${amount.toLocaleString()}`;
};
